// extracted by mini-css-extract-plugin
export default {"imgIcon":"files_icons_imgIcon__0gnVg","docIcons":"files_icons_docIcons__PbJM9"};